module.exports = __webpack_public_path__ + "img/about-icon-04.4bea554e.svg";